import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Presentation from "./components/Presentation";
import Solutions from "./components/Solutions";
import Types from "./components/Types";
import RemplacerReparer from "./components/RemplacerReparer";
import CommentCaSePasse from "./components/CommentCaSePasse";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import CTAAppel from "./components/CTAAppel";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function PosePage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Pose Volet Roulant Strasbourg | Installation Neuf"
        description="Pose et installation de volet roulant neuf à Strasbourg et dans le Bas-Rhin. Manuel ou électrique, sur mesure, devis gratuit. 03 74 47 32 40."
        path="/pose-volet-roulant"
        type="service"
        serviceType="Pose de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Pose volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Pose volet roulant" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Presentation />
        <Solutions />
        <Types />
        <RemplacerReparer />
        <CommentCaSePasse />
        <CTAAppel />
        <FAQ />
        <Galerie />
        <Maillage />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}